var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSort = function SvgSort(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.74994 7.49988C3.74994 7.08566 4.08573 6.74988 4.49994 6.74988H19.4999C19.9142 6.74988 20.2499 7.08566 20.2499 7.49988C20.2499 7.91409 19.9142 8.24988 19.4999 8.24988H4.49994C4.08573 8.24988 3.74994 7.91409 3.74994 7.49988Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.74994 7.49988C3.74994 7.08566 4.08573 6.74988 4.49994 6.74988H19.4999C19.9142 6.74988 20.2499 7.08566 20.2499 7.49988C20.2499 7.91409 19.9142 8.24988 19.4999 8.24988H4.49994C4.08573 8.24988 3.74994 7.91409 3.74994 7.49988Z",
    fill: "currentColor",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.74994 12C6.74994 11.5858 7.08573 11.25 7.49994 11.25H16.4999C16.9142 11.25 17.2499 11.5858 17.2499 12C17.2499 12.4142 16.9142 12.75 16.4999 12.75H7.49994C7.08573 12.75 6.74994 12.4142 6.74994 12Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.74994 12C6.74994 11.5858 7.08573 11.25 7.49994 11.25H16.4999C16.9142 11.25 17.2499 11.5858 17.2499 12C17.2499 12.4142 16.9142 12.75 16.4999 12.75H7.49994C7.08573 12.75 6.74994 12.4142 6.74994 12Z",
    fill: "currentColor",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.74994 16.4999C9.74994 16.0857 10.0857 15.7499 10.4999 15.7499H13.4999C13.9142 15.7499 14.2499 16.0857 14.2499 16.4999C14.2499 16.9141 13.9142 17.2499 13.4999 17.2499H10.4999C10.0857 17.2499 9.74994 16.9141 9.74994 16.4999Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.74994 16.4999C9.74994 16.0857 10.0857 15.7499 10.4999 15.7499H13.4999C13.9142 15.7499 14.2499 16.0857 14.2499 16.4999C14.2499 16.9141 13.9142 17.2499 13.4999 17.2499H10.4999C10.0857 17.2499 9.74994 16.9141 9.74994 16.4999Z",
    fill: "currentColor",
    fillOpacity: 0.2
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSort);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "sort.72ee10197cec8a5162ffa12ea12c3343.svg";